import React from 'react'
import YourCardsActive from 'src/app/YourCardsActive/YourCardsActive'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { yourCardsActiveRouteProps } from 'src/navigation/routeProps'

const YourCardsActiveAppRoute: AppRoute = {
  routeProps: yourCardsActiveRouteProps,
  component: <YourCardsActive />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default YourCardsActiveAppRoute
